import React from 'react'
import { Box, Button, Stack, Typography } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close';
import { customStyles, justifyCenter, spaceBetween } from '../../styles';
import { useContext } from 'react';
import { AppContext } from '../../context';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import HelpOutlineOutlinedIcon from '@mui/icons-material/HelpOutlineOutlined';
import image from '../../assets/images/logo.png'
import { useNavigate } from 'react-router-dom';


export const ModalHeader = ( props ) => {
  const { handleIsOpen } = useContext(AppContext)
  const navigate = useNavigate()

  const handleNavigate = () => {
    navigate('/dashboard/soporte')
  }
  return (
    <Stack direction="row" justifyContent="space-between" mb={5}>
      <Box sx={{ ...spaceBetween, minWidth: 250 }}>
        {
          props?.logo 
          ? <img src={image} alt="global logo" />
          :
            <Typography component="h2" variant="h5" sx={{
              color: props?.color && props?.color,
              fontWeight: props?.bold && '700'
            }}>{props?.text}</Typography>
        }
      </Box>
      <Stack direction="row" alignItems="center">
        {
          props?.backward &&
          // <ArrowBackIosIcon sx={{ color: props?.color, cursor: 'pointer', marginRight: 1 }} onClick={props?.action}/>
          <Button onClick={props?.action} sx={{textTransform: 'capitalize'}}>regresar</Button>
        }
        {
          props?.help &&
          <HelpOutlineOutlinedIcon sx={{ color: customStyles.colors.main, cursor: 'pointer' }} onClick={handleNavigate}/> 
        }
      </Stack>
    </Stack>
  )
}
